import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Vue } from 'vue-property-decorator';
import axios from 'axios';
import { API_URL, MAIN_FILTER_TREE } from '@/App.settings';
import TreeNode from '@/types/TreeNode';
import BaseObjectTypeEnum from '@/enums/BaseObjectTypeEnum';

/** Store de gestion du drag'n'drop d'objet entre les composants (essentiellement arborescence et tableaux enfants de la fiche objet */
@Module({
	namespaced: true
})
class ObjectMoveStore extends VuexModule {
//#region Data
    /** Détermine si un DragNDrop est en cours dans l'application */
    private sourceObjectId: string = "";
    private sourceObjectType: string = "";
    private sourceObjectName: string = "";

//#endregion Data
//#region Mutations

	/** Réinitialisation du store VueX */
	@Mutation
	private reset() {
		this.sourceObjectId = "";
		this.sourceObjectType = "";
		this.sourceObjectName = "";
	}

	@Mutation
    private startMoveObject({ sourceObjectId, sourceObjectType, sourceObjectName }) {
        this.sourceObjectId = sourceObjectId;
        this.sourceObjectType = sourceObjectType;
        this.sourceObjectName = sourceObjectName;
    }

    @Mutation
    private endMoveObject() {
        // Réinitialise le noeud source (drag&drop terminé)
        this.sourceObjectId = "";
        this.sourceObjectType = "";
        this.sourceObjectName = "";
    }
//#endregion Mutations
//#region Actions
	/** Réinitialisation du store VueX */
	@Action({ rawError: true })
	public Reset() {
		this.context.commit('reset');
	}

    @Action({ rawError: true })
    public StartMoveObject({ sourceObjectId, sourceObjectType, sourceObjectName }) {
        this.context.commit('startMoveObject', { sourceObjectId, sourceObjectType, sourceObjectName });
    }

	/** Fin de l'action de drag'n'drop */
	@Action({ rawError: true })
	public async EndMoveObject(targetNodeId: string = "") {
		console.debug("ObjectMoveStore - EndMoveObject - this.sourceObjectId : %O - targetNodeId : %O", this.sourceObjectId, targetNodeId);

		if (targetNodeId === undefined || targetNodeId.trim() === '' || this.sourceObjectId == targetNodeId) {
			console.warn("ObjectMoveStore - EndMoveObject - Pas d'objet cible valide ==> Drag'n'drop annulé !!");
			this.context.commit('endMoveObject');
			return;
		}

		let targetNode: TreeNode = this.context.rootGetters[MAIN_FILTER_TREE + "/Node"](targetNodeId);

		if (targetNode && targetNode.ObjectType == BaseObjectTypeEnum.Client) {
			console.warn("ObjectMoveStore - EndMoveObject - Objet cible client à Drag&droper non autorisé ==> Drag'n'drop annulé !!");
			this.context.commit('endMoveObject');
		}
		else {
			const jsonData = JSON.stringify({ SourceObjectId: this.sourceObjectId, TargetObjectId: targetNodeId });

			// Envoi de la requête de move de l'objet au server
			var data = {
				token: Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "",
				jsonStringData: jsonData
			};

			await axios.post(API_URL + "dataobject/remotemove", data).then((response) => {
				if (response && response.data) {
					// Lance un rafraichissement de la liste des noeuds
					this.context.dispatch(MAIN_FILTER_TREE + "/Refresh", { nodeIdToOpen: targetNodeId } , { root: true });

					// Libère le noeud source
					this.context.commit('endMoveObject');
				}
			});
		}
	}
//#endregion Actions
//#region Getters
	public get GetSourceObjectType(): string {
		return this.sourceObjectType;
	}

	public get GetSourceObjectName(): string {
		return this.sourceObjectName;
	}

	public get GetSourceObjectId(): string {
		return this.sourceObjectId;
	}
	
	/**
	 * Recherche si le type de la cible existe dans la liste des contraintes de la source
	 * @param parentType type source
	 * @param objectType type cible à vérifier
	 */
	private get containsType() {
		return (parentType: string, objectType: string): boolean => {
			// Récupère la contrainte associée au type source
			let globalConstraints = this.context.rootGetters['MenuStore/GetConstraints'];
			let constraints = globalConstraints[parentType];
			// Recherche si le type de la cible existe dans la liste des contraintes de la source
			for (let i = 0; i < constraints?.length; i++) {
				if (constraints[i] === objectType) {
					return true;
				}
			}
			return false;
		}
	}

	public get CheckConstraint () {
		return (targetObjectType: string): boolean => {
			// S'il s'agit de l'arborescence et qu'il y a une source et une cible ?
            if ((this.sourceObjectType !== '') && (targetObjectType !== '')) {
				console.debug("ObjectMoveStore - CheckConstraint() - this.sourceObjectType : %O - targetObjectType : %O - this.containsType(this.sourceObjectType, targetObjectType) : %O", this.sourceObjectType, targetObjectType, this.containsType(this.sourceObjectType, targetObjectType));

				// Si la source et la cible ne sont pas compatibles
                return this.containsType(targetObjectType, this.sourceObjectType);
			}

			return false;
		}
	}
//#endregion Getters
}

export default ObjectMoveStore;